import AddIcon from '@mui/icons-material/Add';

import {EmpionButton} from '../EmpionButton/EmpionButton';

interface EmpionAddButtonRoundedProps {
  onClick: () => void;
}

export const EmpionAddButtonRounded = ({onClick}: EmpionAddButtonRoundedProps) => {
  return (
    <EmpionButton
      variant='contained'
      size='small'
      sx={{
        height: '40px',
        width: '40px',
        minWidth: '40px',
        borderRadius: '50%',
      }}
      onClick={onClick}
    >
      <AddIcon />
    </EmpionButton>
  );
};
